import { Controller, FormProvider } from "react-hook-form";

import { FixedSimpleDropdown } from "src/base-components/FixedSimpleDropdown";
import { JsonRefPath } from "src/schema/jsonRefUtils";
import { SchemaEditorProps } from "src/schema/schemaEditor/types";
import { FEATURES_PROPERTY } from "src/schema/schemaEditor/utils";

interface SchemaTypeSelectorProps extends SchemaEditorProps {
  schemasOptions: Array<{
    key: string;
    value: string;
    internalName?: string;
    schemaName?: string;
  }>;
  hasNoSchemas: boolean;
}

export const SchemaTypeSelector: React.FC<SchemaTypeSelectorProps> = ({
  formMethods,
  isReadonly,
  schemasOptions,
  hasNoSchemas,
}) => {
  return (
    <FormProvider {...formMethods}>
      <Controller
        name="properties"
        render={({ field }) => (
          <FixedSimpleDropdown
            buttonDataLoc="schema-field-type"
            disabled={hasNoSchemas || isReadonly}
            elements={schemasOptions}
            itemsWidth="w-72"
            placeholder={hasNoSchemas ? "No schemas available" : "Select type"}
            placement="bottom start"
            selectedKey={field.value?.[0]?.type?.[0] ?? ""}
            onSelect={(newType) => {
              const selectedSchema = schemasOptions.find(
                (schema) => schema.key === newType,
              );
              field.onChange([
                {
                  fieldName:
                    selectedSchema?.internalName ??
                    selectedSchema?.schemaName?.toLowerCase() ??
                    "",
                  required: true,
                  sensitive: false,
                  type: [newType as JsonRefPath, false],
                },
                FEATURES_PROPERTY,
              ]);
            }}
          />
        )}
      />
    </FormProvider>
  );
};
